import { createContext, FC, PropsWithChildren, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createContextualCan, useAbility } from '@casl/react'
import { getUser } from 'redux/store/user/getters'
import {
  ability,
  defineAbility,
  MyOrganizationCommunityAbility
} from '../Abilities'
import { AnyAbility } from '@casl/ability'

export const MyOrganizationCommunityAbilityContext =
  createContext<MyOrganizationCommunityAbility>(ability)

const MyOrganizationCommunityAbilityProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const user = useSelector(getUser)

  const ability = useMemo(() => defineAbility(user), [user])

  return (
    <MyOrganizationCommunityAbilityContext.Provider value={ability}>
      {children}
    </MyOrganizationCommunityAbilityContext.Provider>
  )
}

export const useMyOrganizationCommunityAbility = () =>
  useAbility<MyOrganizationCommunityAbility>(
    MyOrganizationCommunityAbilityContext
  )

export const Can = createContextualCan<AnyAbility>(
  MyOrganizationCommunityAbilityContext.Consumer
)

export default MyOrganizationCommunityAbilityProvider
